import PropTypes from 'prop-types';
import './tabla.css';

// Anchos de las barras de relleno: varían por fila y columna para que no parezca una rejilla.
const ANCHOS = [78, 62, 90, 54, 70, 84, 58, 66];
const ancho = (fila, col) => `${ANCHOS[(fila * 3 + col) % ANCHOS.length]}%`;

/** Filas de relleno para el cuerpo de una tabla que ya tiene su cabecera (al reordenar o filtrar). */
export const FilasEsqueleto = ({ columnas, filas = 10, conSeleccion = false }) =>
  Array.from({ length: filas }, (_f, i) => (
    <tr key={`esq${i}`} className="tbl-esq-fila" aria-hidden="true">
      {conSeleccion && (
        <td className="tbl-sel">
          <span className="tbl-esq" style={{ width: 14 }} />
        </td>
      )}
      {columnas.map((c, j) => (
        <td key={c.id}>
          <span className="tbl-esq" style={{ width: ancho(i, j) }} />
        </td>
      ))}
    </tr>
  ));

FilasEsqueleto.propTypes = {
  columnas: PropTypes.array.isRequired,
  filas: PropTypes.number,
  conSeleccion: PropTypes.bool,
};

const COLUMNAS_POR_DEFECTO = Array.from({ length: 6 }, (_v, i) => ({ id: `c${i}`, width: 150 }));

/**
 * Marcador de posición con el aspecto de la tabla estándar, mientras llegan las preferencias del
 * usuario y la primera tanda de datos. Dibuja la cabecera con las columnas visibles (si ya se
 * conocen) y filas de relleno; en móvil, tarjetas.
 */
const TablaEsqueleto = ({ columnas = undefined, densidad = 'm', filas = 10 }) => {
  const cols = columnas?.length ? columnas : COLUMNAS_POR_DEFECTO;
  return (
    <div
      className={`tbl tbl-esqueleto tbl-d-${densidad}`}
      role="status"
      aria-busy="true"
      aria-label="Cargando datos"
    >
      <div className="tbl-barra">
        <div className="tbl-barra-titulo">
          <span className="tbl-esq tbl-esq-titulo" />
          <span className="tbl-esq tbl-esq-n" />
        </div>
        <div className="tbl-barra-acciones">
          <span className="tbl-esq tbl-esq-boton" />
          <span className="tbl-esq tbl-esq-boton" />
          <span className="tbl-esq tbl-esq-boton" />
        </div>
      </div>
      <div className="tbl-scroll tbl-esq-escritorio">
        <table className="tbl-tabla">
          <thead>
            <tr>
              {cols.map((c) => (
                <th key={c.id} style={{ width: c.width || 150 }}>
                  <div className="tbl-th">
                    {c.label ? (
                      <span className="tbl-th-txt">{c.label}</span>
                    ) : (
                      <span className="tbl-esq tbl-esq-cabecera" />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: filas }, (_f, i) => (
              <tr key={i} className="tbl-esq-fila">
                {cols.map((c, j) => (
                  <td key={c.id}>
                    <span className="tbl-esq" style={{ width: ancho(i, j) }} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ul className="tbl-tarjetas tbl-esq-movil">
        {Array.from({ length: 5 }, (_f, i) => (
          <li key={i} className="tbl-tarjeta tbl-esq-tarjeta">
            <span className="tbl-esq tbl-esq-titulo" />
            <span className="tbl-esq" style={{ width: '90%' }} />
            <span className="tbl-esq" style={{ width: '70%' }} />
          </li>
        ))}
      </ul>
      <div className="tbl-pie">&nbsp;</div>
    </div>
  );
};

TablaEsqueleto.propTypes = {
  columnas: PropTypes.array,
  densidad: PropTypes.oneOf(['s', 'm', 'l']),
  filas: PropTypes.number,
};

export default TablaEsqueleto;
